import { getDemandPartnersWatcher } from './get-demand-partners.saga';
import { getDefaultSettingsWatcher } from './get-default-settings.saga';

export default [
  getDemandPartnersWatcher(),
  getDefaultSettingsWatcher()
];
